// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Icon from 'shared/components/Icon';
import { newReferralButtonClicked } from '../../../actions/NewReferralActions';
import css from './SideNav.module.scss';

const SidebarLink = ({ isOpen, icon, path, label, notifications = 0 }, context) => (
  <li
    className={cx(css.sidebar_link, css.tooltipped, {
      [css.is_active]: context.router.isActive(path),
    })}
  >
    <Link to={path} className="level is-mobile">
      <div className={cx(css.icon_container, 'level-item')}>
        <Icon name={icon} />
        {notifications && notifications !== 0 ? (
          <div className={css.notifications_badge}>{notifications}</div>
        ) : null}
      </div>
      {isOpen && <div className={cx(css.sidebar_link_label, 'level-item')}>{label}</div>}
    </Link>
    <div className={css.tooltip}>{label}</div>
  </li>
);

SidebarLink.contextTypes = { router: PropTypes.object };

const SideNav = ({ dispatch, isOpen, pendingReferralsCount, currentEmployment }) => (
  <div className={cx(css.SideNav, { [css.has_sidebar_closed]: !isOpen })}>
    <div className={cx(css.quick_action_container, css.tooltipped)}>
      <button className="button is-link" onClick={() => dispatch(newReferralButtonClicked())}>
        <Icon name="new-message" />
        {isOpen && <span style={{ marginLeft: '0.5em' }}>New Referral</span>}
      </button>
      <div className={css.tooltip}>New Referral</div>
    </div>
    <ul className={cx(css.nav_items, { [css.has_sidebar_closed]: !isOpen })}>
      <SidebarLink isOpen={isOpen} icon="home" path="/a/portal/dashboard" label="Dashboard" />
      {/*<SidebarLink
        isOpen={isOpen}
        icon="barcode"
        path="/a/cost_estimates"
        label="Cost Estimate"
      />*/}
      <SidebarLink isOpen={isOpen} icon="calendar" path="/a/calendar" label="Calendar" />
      <SidebarLink
        isOpen={isOpen}
        icon="drawer2"
        path="/a/portal/referrals"
        label="My Referrals"
        notifications={pendingReferralsCount}
      />
      {currentEmployment.features.indexOf('analytics') >= 0 && (
        <SidebarLink isOpen={isOpen} icon="graph" path="/a/analytics" label="Analytics" />
      )}
      <SidebarLink
        isOpen={isOpen}
        icon="gear"
        path="/a/portal/current_agent/edit"
        label="Settings"
      />
      {/*
        <SidebarLink
          isOpen={isOpen}
          icon="info-circle"
          path="/a/portal/current_agent/edit"
          label="Settings"
        />
      */}
    </ul>
  </div>
);

export default connect()(SideNav);
